{
    "title": "Modèles",
    "subtitle": "Choisissez une configuration de journal"
}
